import localeRu from '@angular/common/locales/ru';
import localeEn from '@angular/common/locales/en';

export enum LOCALES {
  ru = 'ru',
  en = 'en'
}

export const ANGULAR_LOCALES = {
  ru: localeRu,
  en: localeEn
};
